import React from 'react';
import { useNotifications, useNovu} from '@novu/react';
import styled from 'styled-components';

import { NotificationItem } from './notification-item';
import { PagePlaceholder } from '../../components/page-placeholder/page-placeholder';

interface NotificationsListProps {
  /**
   *
   */
  ref?: React.Ref<HTMLAnchorElement>;

  /**
    * Additional action to run when clicking on an item
    */
  onItemClick?: () => void;
}

export const NotificationsList: React.FC<NotificationsListProps> = ({
  ref,
  onItemClick
}) => {
  const { notifications, isLoading } = useNotifications();

  if (isLoading) {
    return null;
  }

  if (notifications.length === 0) {
    return (
      <EmptyPlaceholderWrapper>
        <PagePlaceholder
          backgroundImgUrl={'/images/default-background.svg'}
          description="There are no messages to show."
        />
      </EmptyPlaceholderWrapper>
    );
  }

  return notifications.map((notification, index) => (
    <NotificationItem
      ref={index === notifications.length - 1 ? ref : null}
      key={notification.id}
      notification={notification}
      onClick={onItemClick}
    />
  ));
};

const EmptyPlaceholderWrapper = styled.div`
  width: 100%;
  height: 100%;

  div {
    user-select: none;
    background-color: transparent;
    background-size: 24rem;
    max-width: unset;

    p {
      display: inline-block;
      font-weight: 500;
      font-size: 2.4rem;
      color: var(--color-grayscale-cadet, #afb4c0);
    }
  }
`;
